import React, { useEffect, useState } from 'react'
import { request } from 'graphql-request'
import { graphCMSUrl } from '../utils/siteConfig'

const defaultState = {
    visible: false,
    showModal: () => {},
    handleOk: () => {},
    handleCancel: () => {},
    _handleClick: () => {},
}
const ThemeContext = React.createContext(defaultState)

const ThemeProvider = ({ children }) => {
    const [visible, setVisible] = useState(false)
    const [banner, setBanner] = useState({ show: false, content: '', id: '' })

    const showModal = (eventName) => {
        setVisible(true)
        _handleClick(eventName)
    }

    const handleOk = () => {
        setVisible(false)
    }

    const handleCancel = () => {
        setVisible(false)
    }
    const _handleClick = (eventName) => {
        window.analytics.track('Button click', {
            event: eventName,
        })
    }
    const closeBanner = () => {
        localStorage.setItem(banner.id, 'true')
        setBanner({ ...banner, show: false })
    }

    useEffect(() => {
        const fetchProducts = async () => {
            const { headerBanners } = await request(
                graphCMSUrl,
                `
                          {
                            headerBanners(first: 1, stage: PUBLISHED) {
                                id
                                link
                                content {
                                    html
                                }
                            }
                          }
                        `
            )
            if (headerBanners && headerBanners.length){
                if (!localStorage.getItem(`banner-${headerBanners[0].id}`)){
                    setBanner({
                        id: `banner-${headerBanners[0].id}`,
                        content: headerBanners[0].content,
                        link: headerBanners[0].link,
                        show: true,
                    })
                }
            }
        }

        fetchProducts()
    }, [])

    return (<ThemeContext.Provider value={{ visible, showModal, handleOk, handleCancel, _handleClick, banner, closeBanner }}>{children}</ThemeContext.Provider>)
}

export default ThemeContext
export { ThemeProvider }
